import React, { useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import Chart from 'chart.js'
import getIsMobile from 'components/atoms/utils/getIsMobile';

const isMobile = getIsMobile();

export const DoughnutChart = (props) => {
  const { graphData, height } = props;
  
  return (
    <div className="w-full h-full relative" >
      <Doughnut data={graphData} height={isMobile ? 170 : height ? height : 80}/>
      {graphData?.datasets[0].data.length === 0 &&
        <div className='absolute flex left-0 right-0 top-0 bottom-0 items-center justify-center'>
          <b>No data found!</b>
        </div>
      }
    </div >
  )
}
